import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { RoleService } from 'src/app/services/users/role.service';

@Component({
  selector: 'app-list-role',
  templateUrl: './list-role.component.html',
  styleUrls: ['./list-role.component.less']
})
export class ListRoleComponent implements OnInit {

  page:number = 1;
  pageSize:number = 25;
  queryString= "";
  listData:any[];

  constructor(public roleService:RoleService, public messageService:MessageService, public submenuService:SubmenuService)
  { 

  }

  ngOnInit(): void {
    
    this.loadData();
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/roles");    
  }

  loadData(){
    this.messageService.showLoading();
    this.roleService.loadPage(this.page, this.pageSize, this.queryString).subscribe((data:any) => {
        this.listData = data;
        this.messageService.hideLoading();
    },
    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

}
